export default {
  CLICK_18_WINDOW_CONFIRM: 'CLICK_18_WINDOW_CONFIRM'
}
